module.exports = __webpack_public_path__ + "static/media/img83.18c7f0f4.jpg";